export default __webpack_public_path__ + "static/media/madame_detail10.7a003bce.jpg";